/**
 * HTTP Link 설정
 *
 * GraphQL HTTP 요청을 위한 링크 및 인증 헤더 추가
 */

import { HttpLink, ApolloLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

import { ENDPOINTS } from '../config';
import { STORAGE_KEYS, isTokenExpired } from '../storage';

// HTTP 연결 설정
export const httpLink = new HttpLink({
  uri: ENDPOINTS.graphql,
});

// JWT 토큰을 헤더에 추가하는 Auth Link
export const authLink = setContext((operation, { headers }) => {
  const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  const expired = isTokenExpired();

  // 디버그 로그
  if (!token || expired) {
    console.warn('[AuthLink] 토큰 상태 이상:', {
      operationName: operation?.operationName || 'unknown',
      hasToken: !!token,
      isExpired: expired,
      currentTime: new Date().toISOString()
    });
  }

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  };
});
